import { render, staticRenderFns } from "./gift-card-list.vue?vue&type=template&id=2d47ae9f&scoped=true&"
import script from "./gift-card-list.vue?vue&type=script&lang=js&"
export * from "./gift-card-list.vue?vue&type=script&lang=js&"
import style0 from "./gift-card-list.vue?vue&type=style&index=0&id=2d47ae9f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d47ae9f",
  null
  
)

export default component.exports